 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-054765b0":"7a761ced","chunk-0769e715":"9d13adb6","chunk-08048404":"1468d6b0","chunk-0a3b0580":"4479f15d","chunk-0aaf4f59":"e41db4f4","chunk-0b790d3a":"ed54ddec","chunk-1220b765":"77b8192c","chunk-1edcbda8":"8d3acfd2","chunk-1f46f8d0":"879907a2","chunk-21bb0aa4":"5947db33","chunk-26a67b34":"8ab5e75f","chunk-2cf56f9a":"93db36f7","chunk-2d20f987":"4e6ba26f","chunk-3167496f":"9816bd10","chunk-32d10d66":"c501f249","chunk-45723d19":"f0dd323c","chunk-478cd751":"22af5749","chunk-49dfcf7e":"898c714b","chunk-4fcd5e68":"dd2bd8e3","chunk-50a426c0":"73c8388e","chunk-51919a7c":"a002f579","chunk-528917ee":"931ed932","chunk-59bd32c8":"dacbc6b7","chunk-5e271ed2":"8bafa1f4","chunk-618971b7":"5cfe9de5","chunk-6206b86c":"2ff502ef","chunk-62a90a16":"ac5397a1","chunk-63778d00":"c3f8b68e","chunk-64c761e6":"04785e7b","chunk-69b3a464":"025895e3","chunk-6ad9e56e":"c642dd09","chunk-00a9b2cf":"07396e16","chunk-0ad0ca73":"6cd9d624","chunk-1d970094":"884d1281","chunk-3efaed8e":"8a77410b","chunk-448d0df6":"22c3262f","chunk-4b1a778c":"56e41ef3","chunk-62e38887":"c29a4ec0","chunk-67be2903":"cd81440f","chunk-68301903":"a763ed8e","chunk-6db94ea7":"4f5b9263","chunk-795bc5c0":"2219144f","chunk-7df725bc":"2ac7b436","chunk-911ef79a":"5b59c3f8","chunk-a2aa1cf2":"4e0b2f0f","chunk-a985c0ee":"0eeb1798","chunk-abbd5e76":"6db9c9c7","chunk-bbb0d044":"a0745087","chunk-c705faac":"be40d257","chunk-d3612cf2":"4bf3e45e","chunk-e33d0ffc":"5392e4e7","chunk-75b5d810":"2fe63324","chunk-7650db98":"b7ca44e1","chunk-97705c9e":"b58f9f40","chunk-97dbb936":"7b0ad001","chunk-ab313df2":"0d117ea8","chunk-ac047eb2":"1cd57ae3","chunk-c3163c96":"568e3412","chunk-f6cf3a1c":"209b2413"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-0769e715":1,"chunk-08048404":1,"chunk-0a3b0580":1,"chunk-0aaf4f59":1,"chunk-0b790d3a":1,"chunk-1220b765":1,"chunk-1edcbda8":1,"chunk-1f46f8d0":1,"chunk-21bb0aa4":1,"chunk-26a67b34":1,"chunk-2cf56f9a":1,"chunk-3167496f":1,"chunk-32d10d66":1,"chunk-45723d19":1,"chunk-478cd751":1,"chunk-49dfcf7e":1,"chunk-4fcd5e68":1,"chunk-50a426c0":1,"chunk-51919a7c":1,"chunk-528917ee":1,"chunk-59bd32c8":1,"chunk-5e271ed2":1,"chunk-618971b7":1,"chunk-6206b86c":1,"chunk-62a90a16":1,"chunk-63778d00":1,"chunk-64c761e6":1,"chunk-69b3a464":1,"chunk-6ad9e56e":1,"chunk-00a9b2cf":1,"chunk-0ad0ca73":1,"chunk-1d970094":1,"chunk-3efaed8e":1,"chunk-448d0df6":1,"chunk-4b1a778c":1,"chunk-62e38887":1,"chunk-67be2903":1,"chunk-68301903":1,"chunk-6db94ea7":1,"chunk-795bc5c0":1,"chunk-7df725bc":1,"chunk-911ef79a":1,"chunk-a2aa1cf2":1,"chunk-a985c0ee":1,"chunk-abbd5e76":1,"chunk-bbb0d044":1,"chunk-c705faac":1,"chunk-d3612cf2":1,"chunk-e33d0ffc":1,"chunk-75b5d810":1,"chunk-7650db98":1,"chunk-97dbb936":1,"chunk-ab313df2":1,"chunk-ac047eb2":1,"chunk-c3163c96":1,"chunk-f6cf3a1c":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-054765b0":"31d6cfe0","chunk-0769e715":"f6e47170","chunk-08048404":"998b4bec","chunk-0a3b0580":"6aacc310","chunk-0aaf4f59":"cd894d89","chunk-0b790d3a":"b25d9462","chunk-1220b765":"0fea5eb4","chunk-1edcbda8":"4a7e381b","chunk-1f46f8d0":"ceb8c03f","chunk-21bb0aa4":"34342f2b","chunk-26a67b34":"26487049","chunk-2cf56f9a":"07e40232","chunk-2d20f987":"31d6cfe0","chunk-3167496f":"0fea5eb4","chunk-32d10d66":"d04b4e99","chunk-45723d19":"e4d62f25","chunk-478cd751":"b6bdef01","chunk-49dfcf7e":"89a4dd7a","chunk-4fcd5e68":"f73261a0","chunk-50a426c0":"67a589c6","chunk-51919a7c":"e370dcd7","chunk-528917ee":"6b122a3d","chunk-59bd32c8":"b0c80b6f","chunk-5e271ed2":"133d233f","chunk-618971b7":"5465d815","chunk-6206b86c":"201849e9","chunk-62a90a16":"f4b3cc80","chunk-63778d00":"3be6f0e6","chunk-64c761e6":"75c073c1","chunk-69b3a464":"0fea5eb4","chunk-6ad9e56e":"61c887ab","chunk-00a9b2cf":"4f9e4661","chunk-0ad0ca73":"45f8fe76","chunk-1d970094":"4417157e","chunk-3efaed8e":"6ee3598b","chunk-448d0df6":"69f42538","chunk-4b1a778c":"9bdc0443","chunk-62e38887":"71c2d334","chunk-67be2903":"22dddc96","chunk-68301903":"887ab502","chunk-6db94ea7":"f0d7e006","chunk-795bc5c0":"68478bda","chunk-7df725bc":"34e0338a","chunk-911ef79a":"3d0f0a74","chunk-a2aa1cf2":"81f7fe30","chunk-a985c0ee":"7eee0e5d","chunk-abbd5e76":"83cf85e1","chunk-bbb0d044":"a10c4dab","chunk-c705faac":"90840420","chunk-d3612cf2":"1839302a","chunk-e33d0ffc":"ce458712","chunk-75b5d810":"521b9b2c","chunk-7650db98":"74eafba2","chunk-97705c9e":"31d6cfe0","chunk-97dbb936":"c442a025","chunk-ab313df2":"7121534d","chunk-ac047eb2":"aabd98cd","chunk-c3163c96":"0ae62324","chunk-f6cf3a1c":"78f326db"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/platform/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
